import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Switch from 'react-switch';
import Button from '../../../components/CustomButton/CustomButton';
import NotifyAlert from '../../../components/Notify/NotifyAlert';
import PartnerApi from '../../../functions/api/partner/PartnerApi';
import VehicleApi from '../../../functions/api/partner/VehicleDetailApi';
import VehiclePartnerApi from '../../../functions/api/partner/VehiclePartner';
import BrandApi from '../../../functions/api/vehicle/BrandApi';
import TypeApi from '../../../functions/api/vehicle/TypeApi';
import MyUtil from '../../../functions/MyUtil';
import '../../css/About.css';
import '../../css/AddVehicle.css';

class FormAddMotorbike extends Component {
  constructor(props) {
    super(props);
    this.state = {
      types: [],
      brands: [],
      partners: [],
      isLoading: false,
      brand: '',
      imageURL: '',
      selectedFile: null,
      version: '',
      versions: [],
      listMotorbikes: [],
      vhc_part_defa_prie: '',
      partner: '',
      vhc_part_year: '',
      vhc_part_depo: '',
      vhc_part_qaty_tota: '',
      vhc_part_qaty_aval: '',
      vhc_part_crta: '',
      vhc_display: true,
      price_number: null,
    };
  }

  componentDidMount = async () => {
    var brands, types, type, listMotorbikes;
    types = await TypeApi.getAll();
    types = types ? types : [];

    types.forEach((item) => {
      if (item.vhc_type_name === 'Xe máy') type = item;
    });
    var partner = await PartnerApi.getById(this.props.part_id);

    var arr = [];
    brands = await BrandApi.getBrandByType(type.vhc_type_id);
    brands = brands ? brands : [];
    brands.forEach((brand) => {
      arr.push({ value: brand, label: brand.vhc_bran_name, color: '#000' });
    });

    var listVehicle = await VehicleApi.getVehicles();

    if (listVehicle.length > 0) {
      listVehicle.map((item) => {
        if (item.vhc_type_id === 2) {
          listMotorbikes.push(item);
        }
      });
    }

    this.setState({
      brands: arr,
      type: type,
      listMotorbikes,
      partner: partner,
    });
  };

  onChangeSelectPartner = (event) => {
    if (event) {
      this.setState({ partner: event });
    }
  };

  onChangeSelectBrand = async (event) => {
    var { listMotorbikes } = this.state;
    if (event) {
      var arr = [],
        arrVersions = [];

      listMotorbikes = listMotorbikes.filter(
        (value) => value.vhc_bran_id === event.value.vhc_bran_id
      );
      listMotorbikes = listMotorbikes ? listMotorbikes : [];
      listMotorbikes.forEach((item) => {
        arr.push(item['vhc_name']);
      });
      arr = arr.filter(MyUtil.onlyUnique);
      arr.forEach((version) => {
        arrVersions.push({ value: version, label: version, color: '#000' });
      });
      this.setState({ brand: event, versions: arrVersions, version: '' });
    }
  };
  onChangeVersion = async (event) => {
    if (event) {
      this.setState({ version: event });
    }
  };

  handleChange = (event) => {
    if (event.target.name == 'vhc_part_qaty_tota') {
      this.setState({ vhc_part_qaty_aval: event.target.value });
    }

    this.setState({ [event.target.name]: event.target.value });
  };
  handleChangePrice = (event) => {
    var value = event.target.value;
    if (value) {
      var priceNumber = MyUtil.convertMoney(value);
      var priceStr = MyUtil.currencyFormat(priceNumber);
      this.setState({
        price_number: priceStr,
        vhc_part_defa_prie: priceNumber,
      });
    } else {
      this.setState({ price_number: null, vhc_part_defa_prie: '' });
    }
  };

  handleChangeHide = (checked) => {
    this.setState({
      vhc_display: checked,
    });
  };
  onChangeTransmission = (event) => {
    var value = this.state.transmissions.filter(function (item) {
      return item['vhc_tms_id'] == event.target.value;
    });

    this.setState({ transmission: value ? value[0] : '' });
  };

  handleCheck = () => {
    var {
      partner,
      version,
      brand,
      vhc_part_qaty_aval,
      vhc_part_qaty_tota,
      vhc_part_year,
      vhc_part_defa_prie,
    } = this.state;

    if (
      partner &&
      version &&
      brand &&
      Number.isInteger(parseInt(vhc_part_qaty_aval)) &&
      Number.isInteger(parseInt(vhc_part_qaty_tota)) &&
      Number.isInteger(parseInt(vhc_part_year)) &&
      Number.isInteger(parseInt(vhc_part_defa_prie))
    )
      return true;
    return false;
  };
  clearForm = () => {
    this.setState({
      brand: '',
      version: '',
      vhc_part_qaty_aval: '',
      vhc_part_qaty_tota: '',
      vhc_display: true,
      vhc_part_year: '',
      vhc_part_defa_prie: '',
    });
  };

  handleCreate = async () => {
    var {
      partner,
      version,
      brand,
      vhc_part_qaty_aval,
      vhc_part_qaty_tota,
      vhc_part_year,
      vhc_part_defa_prie,
      vhc_display,
    } = this.state;

    if (this.handleCheck()) {
      var vehicle = {
        vhc_name: version.value,
        vhc_part_name:
          brand.value.vhc_bran_name + ' ' + version.value + ' ' + vhc_part_year,
        part_id: partner.part_id,
        part_name: partner.part_name,
        vhc_bran_name: brand.value.vhc_bran_name,
        vhc_part_year: vhc_part_year,
        vhc_part_defa_prie: vhc_part_defa_prie,
        vhc_part_qaty_tota: vhc_part_qaty_tota,
        vhc_part_qaty_aval: vhc_part_qaty_aval,
        vhc_part_hide: vhc_display ? 0 : 1,
        vhc_part_crta: new Date(),
      };
      let result = await VehiclePartnerApi.createVehiclePartner(vehicle);
      if (result && !result['message']) {
        NotifyAlert('Thành công', 'Thêm xe thành công!');
        this.clearForm();
      } else {
        NotifyAlert('Lỗi', result['message']);
      }
    } else {
      NotifyAlert(
        'Thông báo',
        'Dữ liệu bạn nhập chưa đúng. Vui lòng kiểm tra lại!'
      );
    }
  };

  render() {
    const {
      brands,
      version,
      versions,
      brand,
      price_number,
      vhc_part_qaty_aval,
      vhc_part_qaty_tota,
      vhc_part_year,
    } = this.state;

    return (
      <div>
        <div
          style={{
            display: 'inline-flex',
            width: '90%',
            margin: '10px 10px 10px 21px',
          }}
        >
          <Link to="/vehicle-partner">
            <div className="button-back button">
              <img src="ic_back.png" style={{ height: '20px' }}></img>
              <div style={{ fontSize: '16px' }}>Quay lại</div>
            </div>
          </Link>
        </div>
        <div style={{ backgroundColor: '#ececec', margin: '5px 20px' }}>
          <Row className="row-form">
            <div className="row-child">
              <div className="title-content-page">Hãng xe</div>
              <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={brands[0]}
                isLoading={false}
                isSearchable={true}
                name="color"
                placeholder="Chọn hãng xe..."
                options={brands}
                value={brand}
                onChange={this.onChangeSelectBrand}
              />
            </div>

            <div className="row-child">
              <div className="title-content-page">Version</div>
              <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={versions[0]}
                isLoading={false}
                isSearchable={true}
                name="color"
                options={versions}
                value={version}
                onChange={this.onChangeVersion}
              />
            </div>
          </Row>

          <Row className="row-form">
            <div className="row-child">
              <div className="title-content-page">Năm sản xuất</div>
              <input
                className="input-normal full-width"
                placeholder="Nhập năm sản xuất"
                onChange={this.handleChange}
                name="vhc_part_year"
                value={vhc_part_year}
              ></input>
            </div>
            <div className="row-child">
              <div className="title-content-page">Tổng số lượng xe</div>
              <input
                className="input-normal full-width"
                placeholder="Nhập tổng số xe"
                type="number"
                onChange={this.handleChange}
                name="vhc_part_qaty_tota"
                value={vhc_part_qaty_tota}
              ></input>
            </div>

            <div className="row-child">
              <div className="title-content-page">Số xe sẵn dùng</div>
              <input
                className="input-normal full-width"
                placeholder="Nhập số xe sẵn dùng"
                type="number"
                onChange={this.handleChange}
                name="vhc_part_qaty_aval"
                value={vhc_part_qaty_aval}
              ></input>
            </div>
          </Row>

          <Row className="row-form">
            <div className="row-child">
              <div className="title-content-page">Giá cơ bản</div>
              <input
                className="input-normal full-width"
                placeholder="Nhập giá cơ bản"
                onChange={this.handleChangePrice}
                name="vhc_part_defa_prie"
                value={price_number}
              ></input>
            </div>

            <div className="row-child">
              <div className="title-content-page ">Ẩn/Hiện xe</div>
              <div className="row-child" style={{ display: 'block' }}>
                <label className="lable-option" style={{ margin: '0px' }}>
                  <Switch
                    onChange={this.handleChangeHide}
                    checked={this.state.vhc_display}
                    id="normal-switch"
                  />
                </label>
              </div>
            </div>
          </Row>
        </div>
        <Row className="div-save">
          <Button className="btn-edit background" onClick={this.handleCreate}>
            Lưu thay đổi
          </Button>
        </Row>
      </div>
    );
  }
}

export default FormAddMotorbike;
